import { render, staticRenderFns } from "./visualizarStock.vue?vue&type=template&id=4c2a6c40&"
import script from "./visualizarStock.vue?vue&type=script&lang=js&"
export * from "./visualizarStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports